import useAemPath from '@/hooks/aem/useAemPath';

const AemComponent = ({component: Component, itemName, pageName, ...rest}) => {
    const {pagePath, itemPath} = useAemPath(pageName, itemName);

    return <Component pagePath={pagePath} itemPath={itemPath} {...rest} />;
};

export default AemComponent;
